var map = {
	"./harvesterhci.io.virtualmachinebackup": 81955,
	"./harvesterhci.io.virtualmachinebackup.vue": 81955,
	"./kubevirt.io.virtualmachine": 59231,
	"./kubevirt.io.virtualmachine.vue": 59231
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 32642;
module.exports = webpackAsyncContext;